module.exports = __webpack_public_path__ + "img/ic_qrcode_weibo.7a6d009.webp";